import React, { useCallback } from 'react'
import { StoreProductDeliveryType, StoreProductShippingType } from '@/modules/product/types/product'
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material'
import { CartItem } from '@/modules/cart/types/cart'
import { useDispatch } from 'react-redux'
import { updateCartItemShipping } from '@/modules/cart/cartSlice'
import { createLogger } from '@/common/logger'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

const logger = createLogger({prefix: 'CartItemShippingType'})

const useStyles = makeStyles((theme: Theme) => ({
  shippingTypeBox: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
    },
    [theme.breakpoints.up('sm')]: {
    },
  },
  shippingTypeRadio: {
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    },
  }
}))

type CartItemShippingTypeProps = {
  fullWidth?: boolean
  autoUpdate?: boolean
  onUpdate?: (StoreProductDeliveryType) => void
  sx?: any
} & CartItem

const getShippingType = (props: {cartItem?: CartItem, shippingType?: StoreProductDeliveryType}) => {
  const {cartItem} = props
  const productType = cartItem?.product?.deliveryType
  const type = cartItem?.shippingType || productType || props.shippingType
  if (type === 'SHIP_ITEM' || type === 'EVENT_PICKUP') {
    return type
  }
  if (type === 'USER_DECIDES') {
    return ''
  }
  logger.warn("Unable to determine shipping type", cartItem)
  return ''
}

const ShippingItemRadioControl = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { autoUpdate, onUpdate, product, option, quantity, sx } = props
  const currentType = getShippingType(props)
  const onShippingTypeUpdate = useCallback((shippingType: StoreProductShippingType) => {
    if (autoUpdate) {
      dispatch(updateCartItemShipping({
        product,
        option,
        quantity,
        shippingType
      }))
    }
    onUpdate && onUpdate(shippingType)
  }, [dispatch, onUpdate, option, product, autoUpdate, quantity])
  const
    onRadioUpdate = (e: React.SyntheticEvent) => {
      const target = e.target as HTMLInputElement
      const value = target.value as StoreProductShippingType
      onShippingTypeUpdate(value)
    }

  return (
    <FormControl
      sx={{
        ...sx,
        width: '100%'
      }}>

      <RadioGroup
        row={true}
        value={currentType}
        className={classes.shippingTypeRadio}
        onChange={onRadioUpdate}
        name={'shipping-type-buttons-group'}>

        <FormControlLabel
          value={'SHIP_ITEM'}
          control={<Radio size={'small'} sx={{paddingRight: 0}}/>}
          label={<Typography fontSize={12} sx={{marginRight: 0, marginLeft: 1}}>Ship Item</Typography>}/>

        <FormControlLabel
          value={'EVENT_PICKUP'}
          control={<Radio size={'small'} sx={{paddingRight: 0}}/>}
          label={<Typography fontSize={12} sx={{marginRight: 0, marginLeft: 1}}>Event Pickup</Typography>}/>

      </RadioGroup>

    </FormControl>
  )
}

const CartItemShippingType = (props: CartItemShippingTypeProps) => {
  const classes = useStyles()
  const { product } = props
  const { deliveryType } = product

  return (
    <Box className={`ct-shipping-type ${classes.shippingTypeBox}`}>
      {deliveryType === 'USER_DECIDES' &&
        <ShippingItemRadioControl {...props} />
      }
      {deliveryType === 'SHIP_ITEM' &&
        <Typography sx={props.sx} variant={'caption'}>Item will be shipped to user</Typography>
      }
      {deliveryType === 'EVENT_PICKUP' &&
        <Typography sx={props.sx} variant={'caption'}>Item will be picked up at event</Typography>
      }
    </Box>
  ) 
}
export default CartItemShippingType